import React from 'react'

const MakeOrderProductsContext = React.createContext({})

export default MakeOrderProductsContext
